import { environment as env } from '@envs/environment'
import { ApiService } from '@services/api/api-base.service'

export class NotificationApiBaseService extends ApiService<any> {
	override get url(): string {
		return env.url_notification_api
	}

	override sortDirection = {}
}
